// @ts-nocheck
import { configResponsive } from 'ahooks'
import breakpointConfig from '../../constants/mediaBreakPoint.json'

configResponsive(breakpointConfig)
export const configResponsiveHook = (config) => configResponsive(config)
